import type { PerguntaFicha, ValorResposta } from './types';

// Senha da fila: só o número do papel (ex.: 01, 07, 112).
// Letras e símbolos são ignorados e o número sai com 2 dígitos.
// "m7" → "07" · "1" → "01" · "abc" → ""
export function normalizarSenha(texto: string): string {
  const digitos = String(texto ?? '').replace(/\D/g, '');
  if (!digitos) return '';
  // Tira zeros à esquerda e garante 2 dígitos (46 vira "46", 7 vira "07").
  return String(Number(digitos)).padStart(2, '0').slice(0, 4);
}

// Lê um número digitado em português, aceitando vírgula ou ponto.
export function numeroBr(texto: string): number | null {
  if (!texto) return null;
  const n = Number(texto.replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

// Altura em centímetros: "1,72", "1.72" e "172" viram 172.
export function alturaEmCm(texto: string): number | null {
  const n = numeroBr(texto);
  if (n == null) return null;
  return Math.round(n > 0 && n < 3 ? n * 100 : n);
}

export function normalizarAltura(texto: string): string {
  const cm = alturaEmCm(texto);
  return cm == null ? texto : String(cm);
}

export function normalizarPeso(texto: string): string {
  const kg = numeroBr(texto);
  return kg == null ? texto : String(Math.round(kg));
}

export function normalizarCondicaoValor(v: unknown): string | null {
  if (v === null || v === undefined) return null;
  if (v === true) return 'true';
  if (v === false) return 'false';
  return String(v);
}

// Uma pergunta só aparece quando a pergunta da qual ela depende
// (condicaoPerguntaId) já foi respondida com o valor esperado.
export function perguntaVisivel(
  p: PerguntaFicha,
  respostas: Record<string, ValorResposta | undefined>,
): boolean {
  if (p.condicaoPerguntaId == null) return true;
  const resposta = respostas[String(p.condicaoPerguntaId)];
  if (p.condicaoValor === 'true') return resposta === 'true';
  if (p.condicaoValor === 'false') return resposta === 'false';
  if (Array.isArray(resposta)) return resposta.includes(p.condicaoValor as string);
  return resposta === p.condicaoValor;
}